(() => {
  const ROOT = '[data-infinito-gift-card]';
  const NOTE_START = '[INFINITO GIFT CARD DETAILS]';
  const NOTE_END = '[/INFINITO GIFT CARD DETAILS]';

  function initialize(root) {
    if (root.dataset.giftCardInitialized) return;
    const form = root.querySelector('form.form-card');
    const variant = form?.querySelector('[name="id"]');
    if (!form || !variant) return;
    root.dataset.giftCardInitialized = 'true';

    const amounts = [...root.querySelectorAll('.amount-btn')];
    const deliveries = [...root.querySelectorAll('[data-delivery]')];
    const delivery = form.querySelector('[data-gift-card-delivery]');
    const amount = form.querySelector('[data-gift-card-amount]');
    const date = form.querySelector('input[type="date"]');
    const dateField = root.querySelector('.date-field');
    const message = form.querySelector('textarea');
    const submit = form.querySelector('[data-gift-card-checkout]');
    const error = form.querySelector('[data-gift-card-error]');
    const offset = form.querySelector('[name="properties[__shopify_offset]"]');
    const route = window.Shopify?.routes?.root || '/';
    let busy = false;
    let fingerprint;
    let requestId;
    let restoreSideCart;

    function suppressSideCart() {
      restoreSideCart?.();
      let originalOpen;
      let blockedOpen;
      let active = true;
      const install = () => {
        const open = window.openGokwikSideCart;
        if (typeof open !== 'function' || open === blockedOpen) return;
        originalOpen = open;
        blockedOpen = () => Promise.resolve();
        window.openGokwikSideCart = blockedOpen;
        window.closeGokwikSideCart?.();
      };
      install();
      // The cart app can finish loading after this section; guard that case too.
      const interval = setInterval(install, 50);
      const restore = () => {
        if (!active) return;
        active = false;
        clearInterval(interval);
        if (blockedOpen && window.openGokwikSideCart === blockedOpen) window.openGokwikSideCart = originalOpen;
        if (restoreSideCart === restore) restoreSideCart = null;
      };
      restoreSideCart = restore;
      return restore;
    }

    const localDate = (value) => [value.getFullYear(), String(value.getMonth() + 1).padStart(2, '0'), String(value.getDate()).padStart(2, '0')].join('-');
    const refreshDates = () => {
      const today = new Date();
      const lastDay = new Date(today);
      lastDay.setDate(lastDay.getDate() + 90);
      date.min = localDate(today);
      date.max = localDate(lastDay);
      offset.value = String(today.getTimezoneOffset());
    };

    function selectAmount(button) {
      if (!button || button.disabled) return;
      amounts.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      variant.value = button.dataset.variantId;
      amount.value = button.dataset.price;
      root.querySelectorAll('[id^="cardValue-"], [id^="btnPrice-"]').forEach((element) => {
        element.textContent = button.dataset.price;
      });
      variant.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function selectDelivery(button) {
      const later = button.dataset.delivery === 'later';
      deliveries.forEach((item) => {
        item.classList.toggle('active', item === button);
        item.setAttribute('aria-pressed', String(item === button));
      });
      delivery.value = later ? 'Schedule for later' : 'Send instantly';
      dateField.hidden = !later;
      dateField.classList.toggle('visible', later);
      date.disabled = !later;
      date.required = later;
      if (!later) date.value = '';
      refreshDates();
    }

    async function cartRequest(path, body) {
      const response = await fetch(`${route}${path}`, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
      const result = await response.json();
      if (!response.ok) {
        const details = result.description || (result.errors && Object.values(result.errors).flat().join(' ')) || result.message;
        throw new Error(details || 'We could not save your gift card. Please try again.');
      }
      return result;
    }

    function giftNote(cart) {
      const giftItems = cart.items.filter((item) => item.properties?.['_Infinito gift request']);
      const notes = giftItems.map((item, index) => {
        const p = item.properties;
        return [
          `Gift card ${index + 1} — ${p['Gift card amount']}`,
          `Recipient name: ${p['Recipient name']}`,
          `Recipient email: ${p['Recipient email']}`,
          `Sender name: ${p['Sender name']}`,
          `Sender email: ${p['Sender email']}`,
          `Personal message: ${p.Message || ''}`,
          `Delivery: ${p.Delivery}`,
          ...(p['Send on'] ? [`Delivery date: ${p['Send on']}`] : []),
        ].join('\n');
      });
      const existing = cart.note || '';
      const start = existing.indexOf(NOTE_START);
      const end = start < 0 ? -1 : existing.indexOf(NOTE_END, start);
      const customerNote = end < 0 ? existing : existing.slice(0, start) + existing.slice(end + NOTE_END.length);
      return [customerNote.trim(), `${NOTE_START}\n${notes.join('\n\n')}\n${NOTE_END}`].filter(Boolean).join('\n\n');
    }

    async function openCheckout() {
      if (root.dataset.gokwikEnabled !== 'true') {
        window.location.assign(`${route}checkout`);
        return;
      }
      const deadline = Date.now() + 10000;
      while (typeof window.triggerGokwikCustomCheckout !== 'function' || !window.gokwikSdk) {
        if (Date.now() > deadline) throw new Error('Your gift card is saved. Checkout is still loading; please try again.');
        await new Promise((resolve) => setTimeout(resolve, 150));
      }
      window.closeGokwikSideCart?.();
      window.triggerGokwikCustomCheckout();
    }

    amounts.forEach((button) => button.addEventListener('click', () => { if (!busy) selectAmount(button); }));
    deliveries.forEach((button) => button.addEventListener('click', () => { if (!busy) selectDelivery(button); }));
    message.addEventListener('input', () => {
      root.querySelector('[id^="cardMessage-"]').textContent = message.value || 'Your message appears here.';
      root.querySelector('[id^="count-"]').textContent = String(message.value.length);
    });
    selectAmount(amounts.find((button) => button.classList.contains('active') && !button.disabled) || amounts.find((button) => !button.disabled));
    selectDelivery(deliveries.find((button) => button.classList.contains('active')) || deliveries[0]);

    // Keep this out of the cart app's generic add-to-cart button selectors.
    submit.addEventListener('click', () => { if (!busy) form.requestSubmit(); });
    form.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.isComposing && event.target instanceof HTMLInputElement && ['text', 'email'].includes(event.target.type)) {
        event.preventDefault();
        if (!busy) form.requestSubmit();
      }
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;
      form.querySelectorAll('input:not([type="hidden"]):not([type="date"])').forEach((input) => { input.value = input.value.trim(); });
      refreshDates();
      if (!form.reportValidity()) return;
      if (!amounts.some((button) => !button.disabled && button.dataset.variantId === variant.value)) return;
      error.hidden = true;
      busy = true;
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      submit.setAttribute('aria-busy', 'true');
      const restoreDrawer = suppressSideCart();

      try {
        const properties = {};
        for (const [name, value] of new FormData(form)) {
          const match = /^properties\[(.+)\]$/.exec(name);
          if (match && value !== '') properties[match[1]] = value;
        }
        const nextFingerprint = JSON.stringify({ id: variant.value, properties });
        if (fingerprint !== nextFingerprint) {
          fingerprint = nextFingerprint;
          requestId = crypto.randomUUID();
        }
        properties['_Infinito gift request'] = requestId;
        let cart = await cartRequest('cart.js');
        const findGift = (currentCart) => currentCart.items.find((item) => item.properties?.['_Infinito gift request'] === requestId);
        if (!findGift(cart)) {
          await cartRequest('cart/add.js', { items: [{ id: Number(variant.value), quantity: 1, properties }] });
          cart = await cartRequest('cart.js');
        }
        const item = findGift(cart);
        if (!item || String(item.variant_id) !== variant.value || Object.entries(properties).some(([key, value]) => item.properties[key] !== value)) {
          throw new Error('Please try again; your gift card details could not be verified.');
        }
        const note = giftNote(cart);
        const savedCart = await cartRequest('cart/update.js', { note });
        if (savedCart.note !== note) throw new Error('Your gift card is saved, but its note could not be saved. Please try again.');
        window.cart = savedCart;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        await openCheckout();
        // Let the add-to-cart observers finish before normal cart access resumes.
        setTimeout(restoreDrawer, 1500);
      } catch (failure) {
        restoreDrawer();
        error.textContent = failure.message || 'Checkout could not open. Please try again.';
        error.hidden = false;
        error.focus();
      } finally {
        busy = false;
        submit.disabled = false;
        form.removeAttribute('aria-busy');
        submit.removeAttribute('aria-busy');
      }
    }, true);
  }

  const initializeAll = (container = document) => {
    if (container.matches?.(ROOT)) initialize(container);
    container.querySelectorAll(ROOT).forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
